import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useMemo, useRef, useState } from 'react';
import { display } from 'styled-system';
import Box from './Box';
import useOnClickOutside from './hooks/useOnClickOutside';
const DropdownContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = DropdownContext;
const Dropdown = /*#__PURE__*/memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const state = useMemo(() => ({
    isDropdownOpen,
    toggleDropdown: () => {
      setDropdownOpen(!isDropdownOpen);
    },
    openDropdown: () => {
      setDropdownOpen(true);
    },
    closeDropdown: () => {
      setDropdownOpen(false);
    }
  }), [isDropdownOpen]);
  useOnClickOutside(dropdownRef, state.closeDropdown);
  return /*#__PURE__*/React.createElement(Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(_StyledBox, _extends({
    ref: dropdownRef
  }, props), children));
});
Dropdown.propTypes = {
  ...display.propTypes
};
Dropdown.defaultProps = {
  display: 'inline-block'
};
Dropdown.displayName = 'Dropdown';
export default Dropdown;
export { DropdownContext };
var _StyledBox = _styled(Box).withConfig({
  displayName: "Dropdown___StyledBox",
  componentId: "sc-16hpcjq-0"
})({
  position: 'relative'
});